import React from "react";
import classNames from "classnames";
import styles from "./NavigationMenu.module.scss";

interface Props {
    className?: string;
    small?: boolean;
    children: React.ReactNode;
}

export const NavigationMenu: React.FC<Props> = ({
    className,
    small,
    children,
}) => (
    // Keep the global "navigation-menu" class alongside the module class so that
    // Settings.scss (a non-module file) can still override styles via the global selector.
    <nav
        className={classNames(
            styles.navigationMenu,
            "navigation-menu",
            {
                [styles.small]: small,
            },
            className,
        )}
    >
        {children}
    </nav>
);
